import { useMediaQuery } from "@material-ui/core";
import theme from "../../theme";
export var useStateApp = function () {
    return {
        isMobile: useMediaQuery(theme.breakpoints.down("xs")),
    };
};
